import styled from 'styled-components';

export const CheckboxGroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;